import {
    PASSWORD_MIN_LENGTH,
    PASSWORD_MAX_LENGTH,
    CURRENCIES
} from '../constants/constants';
import _ from 'lodash';
import moment from 'moment';
import queryString from 'query-string';
import React from 'react';

const BOLD_ANNOTATION = "$";
const ITALIC_ANNOTATION = "#";

const DEFAULT_BANK_DATA_COUNTRY = "LT";

export class Utils {

    static getParamsFromLocationSearch(data) {
        return queryString.parse(data);
     }

    static convertParamsToLocationSearch(data) {
        return queryString.stringify(data);
    }

    static getOptions(data) {
        let options = [];

        if (!data)
            return options;

        data.forEach((elem) => {options.push({value: elem.code, label: elem.name})});

        return options;
    }

    static getLocationOptions(codes, translations) {
        let formattedData = [];
        if (!_.isNil(codes)) {
            formattedData = codes.map((elem) => {
                return {value: elem, label: _.isNil(translations) ? '' : translations[elem]}
            });
        }

        formattedData = _.sortBy(formattedData, ["label"]);

        return formattedData;
    }

    static getAccreditationGroupOptions(data, emptyOption) {
        if (_.isNil(data) || !_.isArray(data)) {
            return this.getOptions(null, emptyOption);
        }

        let formattedData = data.map((elem) => {
            return {code: elem.id, name: elem.name}
        });

        return this.getOptions(formattedData, emptyOption);
    }

    static getLevelsOptions(data, translations) {
        if (_.isNil(data)) {
            return [];
        }

        return data.map((elem) => {
            return {value: elem, label: _.isNil(translations) ? '' : translations[elem]}
        });
    }

    static getCurrenciesOptions(data) {
        if (_.isNil(data) || !_.isArray(data)) {
            return [];
        }

        return data.map((elem) => {
            return {value: elem, label: CURRENCIES[elem]}
        });
    }

    static getPresetsOptions(data) {
        if (_.isNil(data) || !_.isArray(data)) {
            return [];
        }

        return data.map((elem) => {
            return {value: elem.id, label: elem.name}
        });
    }

    static getBAsOptions(data) {
        if (_.isNil(data) || !_.isArray(data)) {
            return [];
        }

        return data.map((elem) => {
            return {value: elem.id, label: elem.firstName + " " + elem.lastName}
        });
    }

    static isValidPassword(password) {
        return password.length <= PASSWORD_MAX_LENGTH && password.length >= PASSWORD_MIN_LENGTH;
    }

    static objectToFormData(obj) {
        return Object.keys(obj)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]))
            .join('&');
    }

    static stringToBase64(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            })
        );
    }

    static isDateHistorical(date) {
        let boundaryDate = moment().subtract(2, 'months');
        return date < boundaryDate;
    }

    static getTagsFromStringWithStyles(str) {
        let array = this.parseStringToArrayWithStyles(str);

        return _.map(array, (elem, id) => {
            if (elem.italic && elem.bold) {
                return <b key={id}><i>{elem.text}</i></b>;
            } else if (elem.italic) {
                return <i key={id}>{elem.text}</i>;
            } else if (elem.bold) {
                return <b key={id}>{elem.text}</b>;
            } else {
                return <span key={id}>{elem.text}</span>;
            }
        })
    }

    static parseStringToArrayWithStyles(str) {
        let result = [];
        let bold = false, italic = false;

        let text = str.split('').reduce((a, b) => {
            if (b === BOLD_ANNOTATION) {
                if (bold) {
                    if (a !== '') {
                        if (italic)
                            result.push({ text: a, bold: true, italic: true });
                        else
                            result.push({ text: a, bold: true });
                    }
                    bold = false;
                }
                else {
                    if (italic)
                        result.push({ text: a, italic: true })
                    else
                        result.push({ text: a })
                    bold = true;
                }
                return '';
            }
            else if (b === ITALIC_ANNOTATION) {
                if (italic) {
                    if (a !== '') {
                        if (bold)
                            result.push({ text: a, bold: true, italic: true });
                        else
                            result.push({ text: a, italic: true });
                    }
                    italic = false;
                }
                else {
                    if (bold)
                        result.push({ text: a, bold: true })
                    else
                        result.push({ text: a })
                    italic = true;
                }
                return '';
            }
            else {
                return a + b;
            }
        }, '');

        if (text !== '') {
            result.push({ text: text });
        }

        return result;
    }

    static getBankDataByCountry(countryCode, translations) {
        let banksData = _.get(translations, 'payment.bank_data_by_location');

        if (_.isNil(translations) || !banksData) {
            return null;
        }

        return _.get(banksData, countryCode) || _.get(banksData, DEFAULT_BANK_DATA_COUNTRY);
    }

    static getAccreditationFormattedData = (accreditation) => {
        if (_.isNil(accreditation)) {
            return {};
        }

        let data = {
            titleOrig: accreditation.accreditationData.titles.original,
            titleEn: accreditation.accreditationData.titles.en,
            titlesAdditional: {},
            dateIssued: moment(accreditation.accreditationData.issuedAt),
            level: accreditation.accreditationData.level,
            personFirstName: accreditation.verifiedIdentity.firstName,
            personLastName: accreditation.verifiedIdentity.lastName,
            personNationalId: accreditation.verifiedIdentity.nationalId,
            personCountry: accreditation.verifiedIdentity.countryCode
        };

        _.forEach(accreditation.accreditationData.titles, (value, key) => {
            if (key !== 'en' && key !== 'original') {
                data.titlesAdditional[key] = value;
            }
        });

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js